export const SET_WORKSPACE_ASSISTANT_SKILLS = 'SET_WORKSPACE_ASSISTANT_SKILLS';
export const GET_JIRA_CHANNELS = 'GET_JIRA_CHANNEL';
export const GET_BOT_INVITED_SLACK_CHANNELS = 'GET_BOT_INVITED_SLACK_CHANNELS';
export const GET_JIRA_PROJECTS = 'GET_JIRA_PROJECTS';
export const ADD_JIRA_PROJECTS = 'ADD_JIRA_PROJECTS';
export const GET_JIRA_STATUSES = 'GET_JIRA_STATUSES';
export const GET_JIRA_ISSUES = 'GET_JIRA_ISSUES';
export const SET_DEFAULT_JIRA_PERSONAL_CHANNEL =
  'SET_DEFAULT_JIRA_PERSONAL_CHANNEL';
export const SET_DEFAULT_JIRA_CHANNEL = 'SET_DEFAULT_JIRA_CHANNEL';
export const PERSONAL_JIRA_SETTING = 'PERSONAL_JIRA_SETTING';
export const SET_SKILL_DATA = 'SET_SKILL_DATA';
export const SET_CURRENT_SKILL_USER = 'SET_CURRENT_SKILL_USER';
export const GET_JIRA_NOTIFICATION_CONFIGURATION =
  'GET_JIRA_NOTIFICATION_CONFIGURATION';
export const SET_JIRA_NOTIFICATION_CONFIGURATION =
  'SET_JIRA_NOTIFICATION_CONFIGURATION';
export const GET_JIRA_USER_NOTIFICATION_CONFIGURATION =
  'GET_JIRA_USER_NOTIFICATION_CONFIGURATION';
export const SET_JIRA_USER_NOTIFICATION_CONFIGURATION =
  'SET_JIRA_USER_NOTIFICATION_CONFIGURATION';
export const SET_SLACK_CHANNELS = 'SET_SLACK_CHANNELS';
export const SET_SLACK_LINK = 'SET_SLACK_LINK';
export const GET_CHANNEL_DATA = 'GET_CHANNEL_DATA';
export const GET_SKILLSET_DATA = 'GET_SKILLSET_DATA';
export const GET_SKILL = 'GET_SKILL';
export const EMAIL_SUBSCRIPTION = 'EMAIL_SUBSCRIPTION';

export const GET_JIRA_BOARDS = 'GET_JIRA_BOARDS';
export const SET_JIRA_BOARD_SPRINTS = 'SET_JIRA_BOARD_SPRINTS';
export const SET_CURRENT_SKILL = 'SET_CURRENT_SKILLS';
export const SET_CURRENT_TEAMSYNC = 'SET_CURRENT_TEAMSYNC';
export const UPDATE_ASSISTANT_SKILLS = 'UPDATE_ASSISTANT_SKILLS';

//standups:my standups
export const SET_USER_TEAMSYNC = 'SET_USER_TEAMSYNC';
export const SET_USER_TEAMSYNCS = 'SET_USER_TEAMSYNCS';
export const DELETE_USER_TEAMSYNC = 'DELETE_USER_TEAMSYNC';
//standups:show reports
export const SET_TEAM_SYNC_INSTANCE = 'SET_TEAM_SYNC_INSTANCE';
export const SET_PROJECT_PROGRESS_REPORTS = 'SET_PROJECT_PROGRESS_REPORTS';
export const PREV_NXT_INSTANCE_NOT_AVAILABLE =
  'PREV_NXT_INSTANCE_NOT_AVAILABLE';
export const PREV_INSTANCE_NOT_AVAILABLE = 'PREV_INSTANCE_NOT_AVAILABLE';
export const NXT_INSTANCE_NOT_AVAILABLE =
  'NXT_SET_TEAM_SYNC_INSTANCE_RESPONSEINSTANCE_NOT_AVAILABLE';
export const PREV_NXT_INSTANCE_AVAILABLE = 'PREV_NXT_INSTANCE_AVAILABLE';
export const GET_INSTANCE_EMPTY = 'GET_INSTANCE_EMPTY';
export const SET_TEAM_SYNC_INSTANCE_RESPONSE =
  'SET_TEAM_SYNC_INSTANCE_RESPONSE';

export const GET_USERMAPPING_USERS = 'GET_USERMAPPING_USERS';
export const SET_JIRA_USERS = 'SET_JIRA_USERS';

export const SET_LOADING = 'SET_LOADING';
export const ADD_USER_MAPPING = 'ADD_USER_MAPPING';
export const DELETE_USER_MAPPING = 'DELETE_USER_MAPPING';
// Stanups:Resume Now
export const UPDATE_USER_TEAMSYNCS = 'UPDATE_USER_TEAMSYNCS';

// get all the workspace projects
export const SET_PROJECTS = 'SET_PROJECTS';
export const SET_ALL_PROJECTS = 'SET_ALL_PROJECTS';
// To create new project
export const ADD_PROJECT = 'ADD_PROJECT';
// To get a project details
export const SET_PROJECT = 'SET_PROJECT';
export const SET_WORKSPACE_MEMBERS = 'SET_WORKSPACE_MEMBERS';
export const ADD_WORKSPACE_MEMBER = 'ADD_WORKSPACE_MEMBER';
export const SET_USER = 'SET_USER';
export const SET_WORKSPACE = 'SET_WORKSPACE';
export const LEAVE_WORKSPACE = 'LEAVE_WORKSPACE';

//To delete Workspace Members
export const DELETE_WORKSPACE_MEMBER = 'DELETE_WORKSPACE_MEMBER';
//To toggle member role
export const UPDATE_WORKSPACE_MEMBERSHIP = 'UPDATE_WORKSPACE_MEMBERSHIP';
export const EDIT_USER_MAPPING = 'EDIT_USER_MAPPING';
export const UPDATE_TEAMSYNC_INSTANCE_REPORT =
  'UPDATE_TEAMSYNC_INSTANCE_REPORT';

export const SET_CONFULENCE_SPACES = 'SET_CONFULENCE_SPACES';

export const SET_CONFULENCE_CHANNEL_CONFIG = 'SET_CONFULENCE_CHANNEL_CONFIG';
export const SET_CONFULENCE_CHANNEL_CONFIG_LIST =
  'SET_CONFULENCE_CHANNEL_CONFIG_LIST';

export const ADD_CONFLUENCE_CHANNEL_CONFIG = 'ADD_CONFLUENCE_CHANNEL_CONFIG';
export const REMOVE_CONFLUENCE_CHANNEL_CONFIG =
  'REMOVE_CONFLUENCE_CHANNEL_CONFIG';
export const ADD_CHANNEL = 'ADD_CHANNEL';
export const RECENT_REMINDERS = 'RECENT_REMINDERS';
export const APP_HOME_CONFIG = 'APP_HOME_CONFIG';

export const SET_BOT_CHANNEL = 'SET_BOT_CHANNEL';

export const SET_BOT_USERS = 'SET_BOT_USERS';
